'use strict';

(function ($, USHIO) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';

	var modSlider = function modSlider() {
		var arrowPrev = '<button type="button" class="slick-prev"><i class="icon icon-arrow_left"></button>';
		var arrowNext = '<button type="button" class="slick-next"><i class="icon icon-arrow_right"></button>';
		var flag = false;
		$(window).on('resize', function () {
			var winW = $(window).width();
			if (winW > 1024) {
				$('.mod-contsSlider01').not('.slick-initialized').slick({
					infinite: false,
					speed: 1500,
					autoplay: false,
					autoplaySpeed: 2500,
					slidesToShow: 4,
					arrows: true,
					dots: false,
					prevArrow: arrowPrev,
					nextArrow: arrowNext
				});
				$('.mod-contsSlider01 .mod-boxLink03-tit').matchHeight();
			} else {
				$('.mod-contsSlider01.slick-initialized').slick('unslick');
				if ($('.mod-contsSlider01 li').length > 4) {
					$('.mod-contsSlider01-moreSP').css('display', 'block');
				}
			}
		}).resize();

		$('.mod-contsSlider01-moreSP a').on('click', function () {
			if (!flag) {
				$('.mod-contsSlider01').addClass(a);
				$('.mod-contsSlider01-moreSP').addClass(a);
				flag = true;
			} else {
				$('.mod-contsSlider01').removeClass(a);
				$('.mod-contsSlider01-moreSP').removeClass(a);
				flag = false;
			}
		});
	};
	var morecontent = function morecontent() {
		var flag = false;
		if ($('.js-more-content li').length > 4) {
			$('.js-more').css('display', 'block');
		}
		$('.js-more a').on('click', function () {
			if (!flag) {
				$('.js-more-content').addClass(a);
				$('.js-more').addClass(a);
				flag = true;
			} else {
				$('.js-more-content').removeClass(a);
				$('.js-more').removeClass(a);
				flag = false;
			}
		});
	};
	var textTrim = function textTrim() {
		if ($('.js-textTrim').length) {
			// 文字数切り捨て
			var $setElm = $('.js-textTrim');
			var cutFigure = void 0,
			    textLength = void 0,
			    textTrimmed = void 0;
			var afterTxt = '…';
			var lang = location.pathname.split('/')[1];

			if (lang === 'jp') {
				cutFigure = '80';
			} else {
				cutFigure = '120';
			}

			$setElm.each(function () {
				textLength = $(this).text().length;
				textTrimmed = $(this).text().substr(0, cutFigure);

				if (cutFigure < textLength) {
					$(this).html(textTrimmed + afterTxt).css({ visibility: 'visible' });
				} else if (cutFigure >= textLength) {
					$(this).css({ visibility: 'visible' });
				}
			});
		}
	};
	var selectYear = function selectYear() {
		if ($('.mod-selectYear').length) {
			var lang = location.pathname.split('/')[1];
			var category = location.pathname.split('/')[2];
			var directory = location.pathname.split('/')[3];
			var getJSONyear = function getJSONyear(_lang, _category, _directory) {
				return $.getJSON('/' + _lang + '/ajax/' + _category + '/' + _directory + '/exist_year.json');
			};
			getJSONyear(lang, category, directory).then(function (data) {
				var dataList = void 0;
				if (category === 'led') {
					dataList = data.rt_bn_led_featured_article;
				} else {
					dataList = data.rt_bn_ld_news_article;
				}
				var datalist2 = [];
				var datalist2items = void 0;
				console.log('dataList', dataList);
				for (var i = 0; i < dataList.length; i++) {
					var yeardata = dataList[i].ent_cb_date;
					var yeardata2 = yeardata.split('-');
					datalist2items = {
						year: yeardata2[0]
					};
					datalist2.push(datalist2items);
				}
				console.log('datalist2', datalist2);
				// リストから重複を削除
				var list = datalist2;
				// let clearList = list.filter(function(v1, i1, a1) {
				// 	return (a1.findIndex(function(v2){ return (v1.year===v2.year) }) === i1);
				// });
				// IE11でも使える（Babel + polyfill 未使用）
				function filterUniqueItemsById(array) {
					// idを集約した配列を作成
					var itemIds = array.map(function (item) {
						return item.year;
					});
					return array.filter(function (item, index) {
						return itemIds.indexOf(item.year) === index;
					});
				}
				var clearList = filterUniqueItemsById(list);
				console.log('clearList', clearList);
				var $body = $('.mod-selectYear-body');
				if ($body.length > 0) {
					var addText = '';
					if (lang === 'jp') {
						addText = '年';
					}
					var html = '';
					var thisyear = location.pathname.split('/')[4].replace('.html', '');
					for (var l = clearList.length - 1; l >= 0; l--) {
						if (!(thisyear == clearList[l].year)) {
							html += '<li><a href="/' + lang + '/' + category + '/' + directory + '/' + clearList[l].year + ('.html">' + clearList[l].year + addText + '</a></li>');
						}
					}
					if (!(html === '')) {
						$body.append(html);
						$('.mod-selectYear-wrap').removeClass('di_none');
					}
				}
			});

			if ($(window).width() > 1024) {
				$('.mod-selectYear').hover(function (e) {
					$(e.currentTarget).addClass(a);
					$(e.currentTarget).find('.mod-selectYear-body').stop().slideDown(slideSpeed);
				}, function (e) {
					$(e.currentTarget).removeClass(a);
					$(e.currentTarget).find('.mod-selectYear-body').stop().slideUp(slideSpeed);
				});
			} else {
				$('.mod-selectYear-head').on('click', function (e) {
					$(e.currentTarget).toggleClass(a);
					$(e.currentTarget).next('.mod-selectYear-body').stop().slideToggle(slideSpeed);
				});
			}
		}
	};

	modSlider();
	morecontent();
	textTrim();
	selectYear();
})(window.jQuery, window.USHIO);